<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Replace All Banners HTML Content">
            <form action="#" method="POST" class="replaceHTMLContent">
              <div class="form-group">
                <label >Search for:</label>
                <input class="form-control" type="text" placeholder="Ex: https://bonus365.site/fw/go.php?c=:countryCode&a=:affiliateCode" required="required" v-model="search">
              </div>
               <div class="form-group">
                <label >Replace with:</label>
                <input class="form-control" type="text" placeholder="Ex: https://tricdn.site/fw/go.php?c=:countryCode&a=:affiliateCode" required="required" v-model="replace">
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-secondary form-control" @click.prevent="replaceContent">Replace</button>
              </div>
            </form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {

  data () {
    return {
      api_url: '',
      search: '',
      replace: ''
    }
  },
  methods: {

    replaceContent () {
      this.$http.post(`${this.api_url}/banner/replaceContent`, { search: this.search, replace: this.replace }).then((success) => {
        alert(success.data.message)
      }).catch(e => {
        alert(e.data.message)
      })
    }
  },

  computed: {
  },
  created () {
    this.api_url = this.$api_url
  }
}
</script>
